import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ReactNode } from 'react';

interface Props {
  label: ReactNode;
  labelId?: string;
  onClear?: () => void;
  clearAriaLabel?: string;
  showClear?: boolean;
}

const FilterFieldHeader = ({
  label,
  labelId,
  onClear,
  clearAriaLabel,
  showClear = false,
}: Props) => (
  <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
    <FormLabel id={labelId} sx={{ m: 0 }}>
      {label}
    </FormLabel>
    {showClear && onClear && clearAriaLabel && (
      <Tooltip title={clearAriaLabel}>
        <IconButton aria-label={clearAriaLabel} onClick={onClear} size="small" sx={{ padding: 0 }}>
          <FilterAltOffIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </Box>
);

export default FilterFieldHeader;
